import React from "react";
import { View, Text, TextInput } from "react-native";
import { AntDesign } from "@expo/vector-icons";
import TooltipModalWrapper from "../TooltipModalWrapper";
import { tooltips } from "../common/tooltips/tooltips";

interface ChargerEmailInputProps {
  value: string;
  onChange: (text: string) => void;
  error?: string;
}

const ChargerEmailInput: React.FC<ChargerEmailInputProps> = ({
  value,
  onChange,
  error,
}) => {
  const [visible, setVisible] = React.useState(false);
  return (
    <View style={{ marginBottom: 16 }}>
      <View style={{ flexDirection: "row" }}>
        <Text style={{ color: "#fff", marginBottom: 4, fontWeight: "600" }}>
          Charger Email
        </Text>
        <AntDesign
          onPress={() => setVisible(true)}
          name="questioncircle"
          size={16}
          color="#fff"
          style={{ marginLeft: 8 }}
        />
      </View>
      <TextInput
        style={{
          backgroundColor: "#292D33",
          color: "#fff",
          padding: 12,
          borderRadius: 24,
        }}
        placeholder="Enter charger email"
        placeholderTextColor="#8D8E90"
        value={value}
        onChangeText={onChange}
        autoCorrect={false}
      />
      {error ? (
        <Text style={{ color: "red", marginTop: 4 }}>{error}</Text>
      ) : null}
      <TooltipModalWrapper
        visible={visible}
        tooltipData={tooltips.chargerEmailDescription}
        onClose={() => setVisible(false)}
      />
    </View>
  );
};

export default ChargerEmailInput;
